/*
    Create By fanglijuan 2016-10-17
    其他配置相关服务
*/
'use strict';
angular.module("otherConfigurationServiceModule", ["createOtherConfigurationModule"])
    .factory("otherConfigurationService", ["$modal", '$q', function($modal, $q) {
        return {
            //新建or编辑其他配置
            createOrEditOtherConfig: function(otherConfig) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/otherConfiguration/service/create/createOtherCon_tpl.html",
                    windowClass: 'sysManageMent-createOtherConfiguration-window',
                    backdrop: false,
                    controller: "createOtherConfigurationCtrl",
                    resolve: {
                        otherConfig: function() {
                            return otherConfig;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            }
        };
    }]);
